import { useState, useEffect } from 'react';

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');

  const navItems = [
    { label: 'My Work', id: 'projects' },
    { label: 'About Me', id: 'about' },
    { label: 'Skills', id: 'skills' },
    { label: 'Contact', id: 'contact' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);

      // Track active section
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      const sections = ['hero', 'projects', 'testimonials', 'about', 'about-me', 'philosophy', 'skills', 'interests', 'contact'];

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section) {
          const sectionTop = section.offsetTop;
          if (scrollPosition >= sectionTop) {
            setActiveSection(sections[i]);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white shadow-sm border-b border-slate-200'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div
            onClick={() => scrollToSection('hero')}
            className="text-2xl font-bold text-slate-800 cursor-pointer transition-colors duration-300"
            style={{ color: scrolled ? '#6b3d52' : '#1e293b' }}
            onMouseEnter={(e) => e.currentTarget.style.color = '#6b3d52'}
            onMouseLeave={(e) => e.currentTarget.style.color = scrolled ? '#6b3d52' : '#1e293b'}
          >
            Charit Patel
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-sm font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap"
                style={{ color: activeSection === item.id ? '#6b3d52' : '#64748b' }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#6b3d52'}
                onMouseLeave={(e) => e.currentTarget.style.color = activeSection === item.id ? '#6b3d52' : '#64748b'}
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* CTA Button */}
          <button
            onClick={() => scrollToSection('contact')}
            className="hidden md:block px-6 py-2.5 text-white rounded-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ backgroundColor: '#6b3d52' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#7d4a60'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#6b3d52'}
          >
            Let's Talk
          </button>
        </div>
      </div>
    </nav>
  );
}
